export default {
    root: ({ context }) => ({
        class: [
            'flex-1 flex items-center gap-2 justify-between dark:bg-surface-900 text-black dark:text-surface-0/70 p-[1.125rem] font-normal outline-transparent',
            {
                'focus-visible:outline-offset-2 focus-visible:ring-2 focus-visible:ring-brand-primary_medium': !context.disabled,
            },
            {
                'hover:bg-neutral-high_light': !context.disabled && !context.active,
            },
        ],
    }),
    toggleIcon: 'inline-block text-surface-900 dark:text-surface-0 w-4 h-4',
};
